import Vue from 'vue';
export default Vue.component('ed-label', { 
  name: 'ed-label',
  props: ['required']
});